// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-experience__achievement,
.profile-experience__trajectory {
    padding: 24px 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.profile-experience__achievement-title,
.profile-experience__trajectory-team  {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
}

.profile-experience__achievement-title .hubicon-edit,
.profile-experience__trajectory .hubicon-edit {
    font-size: 24px;
    cursor: pointer;
}

.profile-experience__institution.baloa-normal-medium {
    color: var(--basic-gray-color);
    margin-top: 8px;
    margin-bottom: 16px;
}

.profile-experience__details.baloa-normal {
    color: var(--primary-very-dark-color);
    margin-bottom: 16px;
}

.profile-experience__gallery {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: flex-start;
}

.profile-experience__gallery__img {
    height: 150px;
    width: 174px;
}

.profile-experience__gallery__img img{
    height: inherit;
    width: inherit;
    border-radius: 8px;
    object-fit: cover;
}

.profile-experience__trajectory-team__team-data {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;

}

.profile-experience__trajectory-team__team-data__img span.icon-ball {
    border-radius: 50%;
    color: var(--white-color);
    font-size: 44px;
    padding: 4px;
}

.profile-experience__trajectory-team__team-data__img img{
    width: 53px;
    height: 53px;
    border-radius: 50%;
}

.profile-experience__trajectory-team__team-data__data .baloa-subtitle-2 {
    color: var(--primary-dark-color);
    margin-bottom: 8px;
}

.profile-experience__trajectory-team__team-data__data .baloa-normal-medium {
    color: var(--basic-gray-color);
    margin-bottom: 8px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .profile-experience__gallery__img {
        width: 108px;
        height: 100px;        
    }
    .profile-experience__achievement-title .hubicon-edit,
    .profile-experience__trajectory .hubicon-edit {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-experience/ProfileExperienceComponent.style.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,yDAAyD;AAC7D;;AAEA;;IAEI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;;AAE/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,YAAY;QACZ,aAAa;IACjB;IACA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":[".profile-experience__achievement,\n.profile-experience__trajectory {\n    padding: 24px 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.profile-experience__achievement-title,\n.profile-experience__trajectory-team  {\n    display: flex;\n    /* align-items: center; */\n    justify-content: space-between;\n}\n\n.profile-experience__achievement-title .hubicon-edit,\n.profile-experience__trajectory .hubicon-edit {\n    font-size: 24px;\n    cursor: pointer;\n}\n\n.profile-experience__institution.baloa-normal-medium {\n    color: var(--basic-gray-color);\n    margin-top: 8px;\n    margin-bottom: 16px;\n}\n\n.profile-experience__details.baloa-normal {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 16px;\n}\n\n.profile-experience__gallery {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    justify-content: flex-start;\n}\n\n.profile-experience__gallery__img {\n    height: 150px;\n    width: 174px;\n}\n\n.profile-experience__gallery__img img{\n    height: inherit;\n    width: inherit;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.profile-experience__trajectory-team__team-data {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: flex-start;\n\n}\n\n.profile-experience__trajectory-team__team-data__img span.icon-ball {\n    border-radius: 50%;\n    color: var(--white-color);\n    font-size: 44px;\n    padding: 4px;\n}\n\n.profile-experience__trajectory-team__team-data__img img{\n    width: 53px;\n    height: 53px;\n    border-radius: 50%;\n}\n\n.profile-experience__trajectory-team__team-data__data .baloa-subtitle-2 {\n    color: var(--primary-dark-color);\n    margin-bottom: 8px;\n}\n\n.profile-experience__trajectory-team__team-data__data .baloa-normal-medium {\n    color: var(--basic-gray-color);\n    margin-bottom: 8px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .profile-experience__gallery__img {\n        width: 108px;\n        height: 100px;        \n    }\n    .profile-experience__achievement-title .hubicon-edit,\n    .profile-experience__trajectory .hubicon-edit {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
